/**
 * Modal Body Component.
 *
 * @author Ryan Johnston <ryan.johnston@scalesology.com>
 */
import React, { Component } from 'react';

import childrenPropType from 'js/PropTypes/children';

/**
 * Modal Body
 */
class ModalBody extends Component {
    static propTypes = {
        children: childrenPropType,
    };

    static defaultProps = {
        children: null,
    };

    /**
     * Render modal body.
     *
     * @returns {React.node}
     */
    render() {
        const { children } = this.props;

        return (
            <div className="modal-body">
                {children}
            </div>
        );
    }
}

export default ModalBody;
